import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Link from 'flarum/common/components/Link';
/** "GT Ask summary" above the first post: the question people search for, answered in 2 sentences from this thread. */
export default class AskBoxPanel extends Component {
  view() {
    const box = this.attrs.box;
    return m("section", {
      className: 'GtAskBox' + (box.status === 'draft' ? ' GtAskBox--draft' : '')
    }, m("div", {
      className: "GtAskBox-label"
    }, m("i", {
      className: "fas fa-wand-magic-sparkles"
    }), " GT Ask summary", box.status === 'draft' && m("span", {
      className: "GtAskBox-draftTag"
    }, "Draft: only admins see this")), m("h2", {
      className: "GtAskBox-question"
    }, box.question), m("p", {
      className: "GtAskBox-answer"
    }, box.answer), m("div", {
      className: "GtAskBox-foot"
    }, box.helpers.length > 0 && m("span", {
      className: "GtAskBox-by"
    }, "Answered by", ' ', box.helpers.map((h, i) => [i > 0 && ', ', m(Link, {
      href: app.route('user', {
        username: h.username
      })
    }, h.avatarUrl && m("img", {
      className: "GtAskBox-avatar",
      src: h.avatarUrl,
      alt: "",
      loading: "lazy"
    }), h.displayName)]), ' ', "in this thread"), m("span", {
      className: "GtAskBox-links"
    }, box.askSlug && m(Link, {
      href: app.route('ask.show', {
        slug: box.askSlug
      })
    }, "Full answer"), m(Link, {
      className: "GtAskBox-followUp",
      href: app.route('ask') + '?draft=' + encodeURIComponent(box.question)
    }, "Ask a follow-up"))));
  }
}
flarum.reg.add('noriods-ask', 'forum/components/AskBoxPanel', AskBoxPanel);